import { type IProductPageReview } from '@mahawi/eshop-common/dist/src/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Add } from '../icons/add';
import { Remove } from '../icons/remove';
import ReviewAuthenticityNotice from '../review/review-authenticity-notice';
import Stars from '../review/stars';

function ProductReviews({
  reviews,
}: {
  reviews: IProductPageReview[];
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="container--5 container--t container--center review">
      <ReviewAuthenticityNotice />
      {reviews.map((review: IProductPageReview): React.JSX.Element => {
        const key: string = `${review.date}-${review.name}-${review.rating}`;
        const header: string = `${review.flag} ${review.name?.trim() ?? ''}`;

        const prosEls: React.JSX.Element[] = [];
        const consEls: React.JSX.Element[] = [];

        review.pros?.forEach((pro: string): void => {
          prosEls.push(
            <div
              key={pro}
              className="review review--pros-cons-list review--pros-icon"
            >
              <Add />
              <span>{pro}</span>
            </div>,
          );
        });

        review.cons?.forEach((con: string): void => {
          consEls.push(
            <div
              key={con}
              className="review review--pros-cons-list review--cons-icon"
            >
              <Remove />
              <span>{con}</span>
            </div>,
          );
        });

        return (
          <article key={key} aria-label={header} className="review-card">
            <div className="review-card--header">
              <p className="review-card--name">{header}</p>
              <p className="review-card--date">
                {review.date.split('-').reverse().join('.')}
              </p>
            </div>

            {review.rating && (
              <Stars initialRating={review.rating} isDisabled />
            )}

            {review.description && (
              <p className="review-card--description">{review.description}</p>
            )}

            {(prosEls.length > 0 || consEls.length > 0) && (
              <div className="container">
                {prosEls.length > 0 && (
                  <div className="container--5">
                    <h4>{t('review.pros')}</h4>
                    {prosEls}
                  </div>
                )}
                {consEls.length > 0 && (
                  <div className="container--5">
                    <h4>{t('review.cons')}</h4>
                    {consEls}
                  </div>
                )}
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}

export default ProductReviews;
